define(["underscore","@bingads-webui-universal/i18n-model","@bingads-webui-universal/time-zone-converter"], function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__141__, __WEBPACK_EXTERNAL_MODULE__142__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 138);
/******/ })
/************************************************************************/
/******/ ({

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(139);


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "buildLegacyI18n", {
  enumerable: true,
  get: function get() {
    return _buildLegacyI18n.buildLegacyI18n;
  }
});
Object.defineProperty(exports, "mergeLegacyI18ns", {
  enumerable: true,
  get: function get() {
    return _mergeLegacyI18n.mergeLegacyI18ns;
  }
});

var _buildLegacyI18n = __webpack_require__(140);

var _mergeLegacyI18n = __webpack_require__(144);

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLegacyI18n = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _i18nModel = __webpack_require__(141);

var _timeZoneConverter = __webpack_require__(142);

var _failFastSetting = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const buildStringsMap = legacyKeys => _underscore.default.extend({}, ..._underscore.default.flatten([legacyKeys]));

const buildLegacyStrings = (i18n, allStrings) => _underscore.default.mapObject(buildStringsMap(allStrings), str => i18n.getString(str));
/**
 * buildLegacyI18n
 * @param {object} i18n translation object
 * @param {*} legacyKeys array of key to _TL_ strings
 * @param {*} param2 extra options
 * @returns {object} built legacy i18n
 */


const buildLegacyI18n = (i18n, legacyKeys, {
  timeZone,
  currency
} = {}) => // rely on global locale
new _i18nModel.I18nModel({
  timeZone: _underscore.default.isNumber(timeZone) ? (0, _timeZoneConverter.toIANATimeZone)((0, _timeZoneConverter.fromLegacyTimeZone)(timeZone)) : undefined,
  currency,
  loadTranslationData: () => buildLegacyStrings(i18n, legacyKeys),

  loadCLDRData(locale) {
    return locale;
  },

  failFast: (0, _failFastSetting.getFailFastSetting)()
});

exports.buildLegacyI18n = buildLegacyI18n;

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__141__;

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__142__;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFailFastSetting = void 0;
const prodEnvs = ['ads.microsoft.com', 'ui.ads.microsoft.com', 'ui.bingads.microsoft.com', 'bingads.microsoft.com'];

const getFailFastSetting = () => {
  const hostname = window && window.location && window.location.hostname;

  if (hostname && prodEnvs.indexOf(hostname.toLowerCase()) > -1) {
    return 'SAFE';
  }

  return true;
};

exports.getFailFastSetting = getFailFastSetting;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeLegacyI18ns = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _i18nModel = __webpack_require__(141);

var _failFastSetting = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const mergeLegacyStrings = legacyI18ns => _underscore.default.reduce(legacyI18ns, (legacyStrings, i18n) => _objectSpread({}, legacyStrings, i18n.getData()), {});

const mergeLegacyI18ns = legacyI18ns => {
  // All i18n passed should logically use the same timeZone and currency
  const _legacyI18ns$ = legacyI18ns[0],
        timeZone = _legacyI18ns$.timeZone,
        currency = _legacyI18ns$.currency;
  return new _i18nModel.I18nModel({
    timeZone,
    currency,
    loadTranslationData: () => mergeLegacyStrings(legacyI18ns),

    loadCLDRData(locale) {
      return locale;
    },

    failFast: (0, _failFastSetting.getFailFastSetting)()
  });
};

exports.mergeLegacyI18ns = mergeLegacyI18ns;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ })});;
